import { SCRIPT_TYPE } from 'constants/elementTypes'

import isRestorableSrc from './isRestorableSrc'

const DEEP_CLONE = true


export default function unblockNode(blockedNode, config) {
  // Deep cloning is necessary particularly for inlined scripts...otherwise
  // we will replace the tag but lose the JavaScript code within it.
  const node = blockedNode.cloneNode(DEEP_CLONE)
  const src = blockedNode.getAttribute('data-src')

  // Sometimes nodes have an onload handler that needs to be executed
  // to initialize or otherwise execute the code contained therein. If
  // we don't copy the handler (cloneNode() will not do it for us),
  // the node will appear to be blocked, even though the DOM shows
  // that it is not.
  node.onload = blockedNode.onload

  // This is necessary when the user wants to temporarily enable blocked content
  // without storing a consent.
  if ( config?.isTemporary ) {
    node.setAttribute('data-autoblock-ignore', 1)
  }

  if ( node.tagName === 'SCRIPT' ) {
    node.setAttribute('type', SCRIPT_TYPE)
  } else if ( node.tagName === 'IFRAME' ) {
    const iframeID = blockedNode.dataset.termlyIframeId
    const blockedIframeNotice = blockedNode.parentNode.querySelector(`[data-blocked-iframe-id='${ iframeID }']`)

    blockedIframeNotice?.remove()

    if ( node.dataset.display ) {
      node.style.display = node.dataset.display
      node.removeAttribute('data-display')
    } else {
      node.style.display = null
    }
  }

  // Safety net for any address-less element that slipped through blocking
  // with a placeholder `data-src`: only restore a real value. Writing back
  // an empty/"null"/"undefined" src would request <origin>/<that string>.
  //
  if ( node.hasAttribute('data-src') ) {
    if ( isRestorableSrc(src) ) {
      node.setAttribute('src', src)
    }

    node.removeAttribute('data-src')
  }

  if ( node.hasAttribute('data-href') ) {
    node.setAttribute('href', blockedNode.getAttribute('data-href'))
    node.removeAttribute('data-href')
  }

  node.removeAttribute('data-autoblocked')

  return node
}
